'use client';

import React from 'react';
import styled from '@emotion/styled';
import { ChevronDownIcon } from "@argo/ui-elements";
import { colors } from "@argo/principles";
const MobileNavItem = styled('label')`
  display: flex;
  justify-content: space-between;
  align-content: center;

  span {
    color: ${colors.primary.white};
  }

  svg {
    float: right;
  }
`;
const ExpanderContent = styled('div')`
  background: ${colors.blue.mutedBlue};
`;
export const ExpanderToggler = styled('input')`
  display: none;

  + label {
    display: block;
    position: relative;
    z-index: 1;
    background: transparent;
    transition-delay: .5s;
    will-change: background-color;

    svg {
      transform: rotate3d(0, 0, 1, 0deg);
      transition: transform .5s ease;
      will-change: transform;
      backface-visibility: hidden;
    }
  }

  &:checked + label {
    background: ${colors.blue.mutedBlue};
    transition: background 50ms;
    transition-delay: 0;

    svg {
      transform: rotate3d(0, 0, 1, -180deg);
      transition: transform .5s ease;
    }
  }

  ~ div {
    background-color: ${colors.blue.mutedBlue};
    position: relative;
    padding-bottom: 0;
    overflow: hidden;
    max-height: 0;
    transition: max-height .5s ease;
  }

  &:checked ~ div {
    max-height: 600px;
    transition: max-height 1s ease;

    a {
      line-height: 16px;
    }
  }
`;
export default ({
  link,
  menuIndex,
  children
}) => {
  return React.createElement(React.Fragment, null, React.createElement(ExpanderToggler, {
    type: 'checkbox',
    id: link.id
  }), React.createElement(MobileNavItem, {
    htmlFor: link.id,
    "data-analytics": link.omnitureTag,
    "data-partner": link.partnerLink,
    "data-tag-id": `PrimaryNavList${menuIndex}`,
    "data-index": menuIndex
  }, React.createElement("span", null, link.name), React.createElement(ChevronDownIcon, {
    size: '20',
    color: 'white'
  })), React.createElement(ExpanderContent, null, children));
};